import React from 'react';
import { TFunction } from 'i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';

type Args = {
  selectedItemsCount: number;
  onRemoveSelected: () => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableActionsForSelected(args: Args) {
  const { selectedItemsCount, onRemoveSelected, t } = args;

  return [
    <Button
      key="remove-selected"
      buttonText={`${t('remove')} (${selectedItemsCount})`}
      buttonType={ButtonTypes.negativeOutlined}
      leftIcon="cancel"
      onClick={onRemoveSelected}
    />,
  ];
}
